import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import getStages from '../../services/stage/getStagesByDossierSubtype'
import { showLoader, hideLoader } from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import { fetchCombosSuccess } from '../../actions/combos/combos'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'

export function * fetchStages ({ dossierSubtypeId, ignoreStoredAndCancelled }) {
  try {
    yield put(showLoader())
    const auth = yield select(getAuth)
    let stagesCombo = []
    if (dossierSubtypeId) {
      stagesCombo = yield call(getStages, auth.token, dossierSubtypeId, ignoreStoredAndCancelled)
    }
    yield put(fetchCombosSuccess({ stagesCombo }))
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }
    yield call(handleError, { error, customHandler })
  } finally {
    yield put(hideLoader())
  }
}

export function * watchFetchStages () {
  yield takeLatest(combosActionTypes.FETCH_STAGES_COMBO, fetchStages)
}
